export interface IFileConfig {
	label: string;
	color: string;
	extensions: readonly string[];
	hasPreview: boolean;
}

export const FILE_TYPES = {
	pdf: {
		label: "PDF",
		color: "#D92D20",
		extensions: ["pdf"],
		hasPreview: true,
	},
	word: {
		label: "DOC",
		color: "#155EEF",
		extensions: ["doc", "docx"],
		hasPreview: false,
	},
	excel: {
		label: "EXCEL",
		color: "#1A7F37",
		extensions: ["xls", "xlsx", "csv"],
		hasPreview: true,
	},
	json: {
		label: "JSON",
		color: "#F59E0B",
		extensions: ["json"],
		hasPreview: true,
	},
	image: {
		label: "IMG",
		color: "#7C3AED",
		extensions: ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"],
		hasPreview: true,
	},
	video: {
		label: "VIDEO",
		color: "#DC2626",
		extensions: ["mp4", "webm", "ogg", "avi", "mov", "wmv"],
		hasPreview: true,
	},
	audio: {
		label: "AUDIO",
		color: "#9333EA",
		extensions: ["mp3", "wav", "aac", "flac", "ogg", "wav"],
		hasPreview: true,
	},
	text: {
		label: "TEXT",
		color: "#059669",
		extensions: [
			"txt",
			"log",
			"md",
			"yaml",
			"yml",
			"ini",
			"conf",
			"config",
			"html",
			"css",
			"js",
			"ts",
			"tsx",
			"jsx",
			"py",
			"java",
			"cpp",
			"c",
			"h",
			"php",
			"rb",
			"go",
			"rs",
			"swift",
			"kt",
			"scala",
			"sql",
		],
		hasPreview: true,
	},
	xml: {
		label: "XML",
		color: "#DC2626",
		extensions: ["xml", "xsd", "xsl", "xslt"],
		hasPreview: true,
	},
	default: {
		label: "FILE",
		color: "#6C757D",
		extensions: ["*"],
		hasPreview: false,
	},
} as const satisfies Record<string, IFileConfig>;

export type FileType = keyof typeof FILE_TYPES;

export const getFileType = (extension: string): FileType => {
	const ext = extension.toLowerCase();
	const extWithoutDot = ext.startsWith(".") ? ext.slice(1) : ext;

	for (const [key, config] of Object.entries(FILE_TYPES)) {
		if (key !== "default" && (config.extensions as readonly string[]).includes(extWithoutDot)) {
			return key as FileType;
		}
	}

	return "default";
};
